// extracted by mini-css-extract-plugin
export var pillWrapper = "_qn-0";
export var showOverflow = "_qn-1";